import React, { useMemo, useState } from "react";
import { T } from "../theme";
import { Card } from "../ui";

function isFeatured(l) {
  const until = l.featuredUntil?.toDate ? l.featuredUntil.toDate() : null;
  return !!(until && until > new Date());
}

export default function RepairDirectoryScreen({ activeListings, myListings, onSelect, onSelectMine, onAdd, canPost }) {
  const [tab, setTab] = useState("browse");

  const sortedListings = useMemo(() => {
    return [...activeListings].sort((a, b) => Number(isFeatured(b)) - Number(isFeatured(a)));
  }, [activeListings]);

  return (
    <div>
      <div style={{ display: "flex", background: T.statBg, borderRadius: 10, padding: 4, marginBottom: 14 }}>
        {[["browse", "Browse"], ["mine", "My Listing"]].map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)} style={{ flex: 1, background: tab === key ? T.accent : "transparent", border: "none", color: tab === key ? "#fff" : T.muted, padding: "8px 0", borderRadius: 7, cursor: "pointer", fontSize: 12, fontWeight: "bold", fontFamily: T.font, letterSpacing: "0.08em" }}>{label}</button>
        ))}
      </div>

      {tab === "browse" && (
        <div>
          {sortedListings.length === 0 ? (
            <div style={{ textAlign: "center", padding: 32, fontSize: 13, color: T.muted }}>No repair providers listed yet.</div>
          ) : (
            sortedListings.map((l) => (
              <Card key={l.id} onClick={() => onSelect(l)} style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer", border: isFeatured(l) ? `1px solid ${T.accentAlt}` : undefined }}>
                {l.photoUrls?.[0] && (
                  <img src={l.photoUrls[0]} alt="" style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 8, flexShrink: 0 }} />
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <div style={{ fontSize: 14, fontWeight: "bold", color: T.text }}>{l.providerName}</div>
                    {isFeatured(l) && <span style={{ fontSize: 9, color: T.value, fontWeight: "bold" }}>⭐ FEATURED</span>}
                  </div>
                  <div style={{ fontSize: 11, color: T.muted, marginTop: 4 }}>{(l.services || []).join(" · ")}</div>
                  {l.priceRange && <div style={{ fontSize: 12, color: T.value, fontWeight: "bold", marginTop: 4 }}>{l.priceRange}</div>}
                </div>
              </Card>
            ))
          )}
        </div>
      )}

      {tab === "mine" && (
        <div>
          {canPost && myListings.length === 0 && (
            <button onClick={onAdd} style={{ width: "100%", background: T.btnBg, border: "none", color: "#fff", padding: 12, borderRadius: 8, fontSize: 12, fontWeight: "bold", letterSpacing: "0.1em", cursor: "pointer", fontFamily: T.font, marginBottom: 12 }}>
              + Become a Repair Provider
            </button>
          )}
          {myListings.length === 0 ? (
            <Card style={{ textAlign: "center", padding: 24 }}>
              <div style={{ fontSize: 13, color: T.muted }}>{canPost ? "You haven't listed a repair service yet." : "Vault Supreme is required to list a repair service."}</div>
            </Card>
          ) : (
            myListings.map((l) => (
              <Card key={l.id} onClick={() => onSelectMine(l)} style={{ cursor: "pointer", opacity: l.status === "paused" ? 0.6 : 1 }}>
                <div style={{ fontSize: 14, fontWeight: "bold", color: T.text }}>{l.providerName}</div>
                <span style={{ fontSize: 9, color: l.status === "paused" ? T.muted : T.accent, fontWeight: "bold", letterSpacing: "0.05em", textTransform: "uppercase" }}>{l.status}</span>
              </Card>
            ))
          )}
        </div>
      )}
    </div>
  );
}
